<template>
  <div class="uk-section ba-secondary-section">

    <div class="uk-container">

      <div class="uk-flex-center" uk-grid>
        <div class="uk-width-1-1 uk-text-center">
          <h1 class="uk-h2 uk-margin-remove-bottom">Clients love us</h1>
        </div>

        <div class="uk-margin-large-top uk-width-1-2@m uk-width-1-1@s">
          <div class="uk-slider-container" uk-slider="autoplay: true">
            <div class="uk-position-relative uk-visible-toggle uk-light">

              <ul class="uk-slider-items uk-child-width-1-1@s">
                <li
                  v-for="(testimonial, index) in testimonials"
                  v-bind="testimonial"
                  v-bind:key="index"
                >
                  <p class="uk-text-justify">{{ testimonial.blurb }}</p>
                  <p class="author uk-text-right">– {{ testimonial.author }}</p>
                </li>
              </ul>

            </div>

            <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>

          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
	name: 'Testimonials',
	data: function () {
		return {
			testimonials: [
				{
					blurb: 'Must say I’m very pleased with my VPS, and have never seen such a great offer. Initially had problems with the IP but it was resolved and my ticket was answered. I recommend this service.',
					author: 'Joost@lowendbox.com'
				},
				{
					blurb: 'While many VPS service providers offer quick a response, BitAccel is probably one of the few vps providers that offer a truley "active" response. Rather than waiting for issues to happen and clients to complain they proactively monitor the situation which would probably do a great amount of good deal to their business reputation.',
					author: 'Admin@96mb.com'
				},
				{
					blurb: 'I bought a VPS for VNC usage (to get past site blockers and to play Runescape on my android phone) and I must say I am very impressed. For a 2GB VPS with 1TB bandwidth and 2 cores the price was fantastic. Setup was literally instant, too. Highly recommend these guys.',
					author: 'Pebsie@lowendtalk.com'
				},
				{
					blurb: 'I would like to provide a strong recommendation for BitAccel. BA-Corey is very sharp technically, and his customer support is the best. This is a superb offer, not to be missed. Disclaimer: No relationship to BitAccel or BA-Corey, other than as a satisfied customer.',
					author: 'EMG@lowendbox.com'
				}
			]
		}
	}
}
</script>

<style scoped lang="less">
.ba-os-icon p {
  font-size: 24px;
}
p {
  font-size: 18px;
}
.author {
  color: rgba(255, 255, 255, 0.5);
}
</style>
